import React from "react";
import styled from "styled-components";
import moment from "moment";
import { colors } from "@sonder/ui/source/styled/theme";

const Text = styled.div`
  color: ${colors.gray6};
  font-size: 0.857rem;
  font-weight: 500;
`;

interface SearchCardCreatedAtProps {
  createdAt: string;
}

export const SearchCardCreatedAt = ({
  createdAt,
}: SearchCardCreatedAtProps) => {
  const formattedCreatedAt = `Created ${moment(createdAt).fromNow()}`;

  return <Text>{formattedCreatedAt}</Text>;
};
